module.exports = __webpack_public_path__ + "static/img/bg_bosch.b0de4ac.ff83056.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia/bg_bosch.b0de4ac.svg
// module id = nBwM
// module chunks = 1